import React, { useState } from 'react'
import Button from 'UI/Button/Button'
import useCustomMessage from 'hooks/useCustomMessage'

interface ExportButtonProps {
  onExport: () => void
  icon?: React.ReactNode
  children?: React.ReactNode
  disabled?: boolean
}

const ExportButton = ({ onExport, icon, children, disabled }: ExportButtonProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const { openMessage, contextHolder } = useCustomMessage()

  const handleClick = async () => {
    setIsLoading(true)
    try {
      await onExport()
      openMessage('success', 'File successfully exported')
    } catch {
      openMessage('error', 'File export failed, please try again later')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {contextHolder}
      <Button loading={isLoading} buttonType='primary' icon={icon} onClick={handleClick} disabled={disabled}>
        {children}
      </Button>
    </>
  )
}

export default ExportButton
